module.exports = __webpack_public_path__ + "img/slide2.ca9039fb.png";